import { Component } from '@angular/core';

@Component({
  selector: 'app-error-privacynotice',
  templateUrl: './error-privacynotice.component.html',
})
export class ErrorPrivacyNoticeComponent {}
